(function ($, window, undefined) {

    (function () {
        'use strict';

        var animacaoAbrirAcc = function () {

            $('#criar-conta').fadeIn();

            $('body').css({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' }).addClass('onCreateAcc');


        };

        var verificarHashAcc = function () {

            var hash = window.location.hash;

            if (hash === '#criar-conta') {

                animacaoAbrirAcc();

            }

        };



        // Fazer login mask
        $('.create-acc-link').on('click', function (event) {

            event.preventDefault();

            window.location.hash = 'criar-conta';

        });

        $(window).on('load', function () {
            verificarHashAcc();
        });

        $(window).on('hashchange', function () {
            verificarHashAcc();
        });

        $(document).on('touchmove mousewheel DOMMouseScroll', '#criar-conta', function (e) {
            e.preventDefault();
        });

        
    }());

    $('#criar-conta').niceScroll();



    var animacaoFecharAcc = function () {

        setTimeout(function () {
            $('#criar-conta').fadeOut();
        }, 200);

        window.location.hash = '';

        $('body').css({ 'overflow-y': 'visible', 'overflow-x': 'visible' }).removeClass('onCreateAcc');


    };

    $('#criar-conta .btn-fechar').on('click', function () {

        animacaoFecharAcc();

    });



}(jQuery, window));